import { Map } from 'immutable';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Link from 'next/link';
import useStores from '../../../utils/useStores';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';

const ContactSection = atomicBlock({ alignment: false })(() => {
  return (
    <Box mb={8} pt={8}>
      <Box mb={4}>
        <Typography align="center">
          Sie wollen an diesem Event teilnehmen?
        </Typography>
      </Box>
      <Box textAlign="center">
        <Link href="/kontakt" passHref>
          <Button variant="outlined" target="_blank">
            Kontaktieren Sie uns
          </Button>
        </Link>
      </Box>
    </Box>
  );
});

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const { page, readOnly } = getProps();
    const type = block.getType();
    if (type === 'event-contact') {
      return {
        component: ContactSection,
        editable: false,
        props: {
          page,
          readOnly,
        },
      };
    }
    return null;
  },
  // blockStyleFn: (block, { getProps }) => {
  //   const { page, readOnly } = getProps();
  //   const type = block.getType();
  //   const data = block.getData();
  //   const alignment = data.get('alignment');
  //   return cx(
  //     // default overwrites
  //     style[page.type],
  //     style[alignment],
  //     { [style.addToCalendar]: type === 'event-contact' },
  //   );
  // },
  blockRenderMap: Map({
    'event-contact': {
      element: 'div',
      props: {},
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
});

export default plugin;
